<div class="cnt-participant">

    <div class="row" *ngFor="let item of participants; index as i">
  
      <div class="col-12">
        <span class="name">{{item}}</span><i class="material-icons kick" (click)="kickUser(item)">close</i>
      </div>
  
    </div>
  </div>